import { FolderOpenOutlined } from '@ant-design/icons';
import { InspectorWrapper } from '@smx-ui-inspector/inspector-wrapper';
import { Divider, Flex, Layout, Menu, theme } from 'antd';
import { Outlet, useNavigate } from 'react-router-dom';

import { API, paths } from '../common';
import { Logo } from '../components/logo';

const { Header, Sider, Content } = Layout;

const TopLayout = () => {
    const navigate = useNavigate();

    const {
        token: { colorBgContainer },
    } = theme.useToken();

    const getDefaultKeyForMenu = () => {
        const currentUrl = window.location.href;
        if (currentUrl.includes('sharing-document')) {
            return 1;
        }
        return 1;
    };

    return (
        <Flex flex={1} style={{ height: '100%' }}>
            <Sider width={160} collapsible style={{ background: colorBgContainer }}>
                <Flex justify="center" style={{ borderInlineEnd: '1px solid rgba(5, 5, 5, 0.06)' }}>
                    <Logo type={'short'} margin={'10px'} />
                </Flex>
                <Divider style={{ margin: '1px 10px', minWidth: 'calc(100% - 20px)', width: 'calc(100% - 20px)' }} />
                <Menu
                    style={{ height: '100%' }}
                    theme="light"
                    mode="inline"
                    defaultSelectedKeys={[getDefaultKeyForMenu().toString()]}
                    items={[
                        {
                            key: '1',
                            icon: <FolderOpenOutlined />,
                            label: 'Documents',
                            onClick: () => {
                                navigate(paths.DOCUMENT_LIST);
                            },
                        },
                    ]}
                />
            </Sider>
            <Layout style={{ width: '10%' }}>
                <Header
                    style={{
                        padding: '0 20px',
                        background: colorBgContainer,
                        alignItems: 'center',
                        borderInlineStart: '1px solid rgba(5, 5, 5, 0.06)',
                    }}
                >
                    <Flex justify={'space-between'}>
                        <Flex justify="start">
                            <label style={{ fontWeight: 'bold', fontSize: 20 }}>Sitemax - Contractor</label>
                        </Flex>
                    </Flex>
                </Header>
                <Divider style={{ margin: '0px 10px', minWidth: 'calc(100% - 20px)', width: 'calc(100% - 20px)' }} />
                <Content
                    style={{
                        padding: 24,
                        background: 'white',
                        overflow: 'scroll',
                    }}
                >
                    <Outlet />
                    <InspectorWrapper filterProject={API.PROJECT_FILTER?.split(',')} />
                </Content>
            </Layout>
        </Flex>
    );
};

export default TopLayout;
